import { render, staticRenderFns } from "./Home.data-manager.vue?vue&type=template&id=971e22a8&scoped=true&"
import script from "./Home.data-manager.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager.vue?vue&type=style&index=0&id=971e22a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971e22a8",
  null
  
)

export default component.exports